import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import CuponsList from './components/CuponsList';

const Cupons = () => (
  <Container className="dashboard">
    <Row>
      <Col md={12}>
        <h3 className="page-title">Cupons</h3>
        <h3 className="page-subhead subhead">
          Exibindo todos os cupons inscritos na plataforma.
        </h3>
      </Col>
    </Row>
    <Row>
      <CuponsList />
    </Row>
  </Container>
);

export default Cupons;
